import { DataHeader, LookupModelSearchEvent, Tab } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutTariffManagement } from "./autogen/AutogenLayoutTariffManagement";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";
import { TariffManagementUtil } from "./TariffManagementUtil";

export class TariffManagement extends AutogenLayoutTariffManagement {

    override onLoad() {
        this.styleTab(this.tabTariffDetailsId);
        this.validateTariffManagementRecordExist();
        TariffManagementUtil.setCurrencyTextboxState(this.textboxDefaultCurrency);
    }

    styleTab(tab: Tab) {
        tab.heading.setProps({ color: "subtle.light", fontBold: false, borderWidth: 0 });
        tab.headingLabel.setProps({ color: "McLeodPrimary", fontSize: "xlarge", fontBold: true });
    }

    public override async doAfterDataHeaderSetup(dataHeader: DataHeader): Promise<void> {
        dataHeader.showDelete = true;
        dataHeader.promptToSaveChanges();
    }

    private validateTariffManagementRecordExist() {
        const tariffManagementUrl = "lme/dispatch/TariffManagement?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "tariff", screenName: "TariffManagement", navigateToUrl: tariffManagementUrl, altFieldNameForDupCheck: "tariff_id", primaryKeyFieldNameForAlt: "tar_uid" };
        DuplicateId.configureIdTextbox(this.textboxTariffId, validateProps);
    }

    textboxFallbackTariffIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.from_fallback = true;
        const tariffTypeCode = this.textboxTariffTypeCode.selectedItem?.value;
        event.filter.tariff_type_code = tariffTypeCode === "E" ? "S" : tariffTypeCode;
        const tariffId = this.textboxTariffId.text;
        if (!StringUtil.isEmptyString(tariffId)) {
            event.filter.tariff_id = `<>${tariffId}`;
        }
    }

}
